import { FC } from "react";
import { Tooltip } from "antd";
import { SvgIcon } from "../../../../common/components/SvgIcon";
import { Reputation } from "../../../../types/IntelligenceTypes";
import { GenericCard } from "../../../../common/components/GenericCard";
import styles from "./RegulationAndClient.module.less";

function getRatingClass(risk?: string) {
    switch (risk) {
        case "high":
            return styles.ratingHigh;
        case "low":
            return styles.ratingLow;
        case "medium":
            return styles.ratingMedium;
        default:
            return styles.ratingMedium;
    }
}

interface RegulationAndClientProps {
    data?: Reputation;
}

export const RegulationAndClient: FC<RegulationAndClientProps> = ({ data }) => {
    const ratingTypeClass = getRatingClass(data?.rating);
    const points = data?.feedbacks.concat(data?.comments);
    const rating = data?.rating || "-";

    return (
        <GenericCard size="larger" className={styles.card}>
            <div className={styles.content}>
                <div className={styles.titleRow}>
                    <div className={styles.title}>Regulation and client feedback score</div>
                    <Tooltip title="This metric combines regulatory compliance and client feedback to assess vendor's business's operational integrity and customer satisfaction. Balancing these factors is essential for long-term success and reputation management.">
                        <SvgIcon name="help" size={12} color="#1890FF" />
                    </Tooltip>
                </div>
                <div className={styles.contentMain}>
                    <div className={`${styles.rating} ${ratingTypeClass}`}>{rating}</div>
                </div>
                <ul className={styles.points}>{points?.map((p) => <li key={p}>{p}</li>)}</ul>
            </div>
        </GenericCard>
    );
};
